/**
 * A/B Test: Product Recommendations Position
 * Feature Flag: shopify-block
 *
 * Control: 推荐产品保持原位置（在页面底部，评价下方）
 * Test: 推荐产品移动到 main-product section 后面（评价上方）
 */
(function() {
  'use strict';

  var FLAG_NAME = 'shopify-block';
  var TEST_VARIANT = 'test';
  var TIMEOUT_MS = 3000;

  // 仅在产品页运行
  if (window.location.pathname.indexOf('/products/') === -1) {
    return;
  }

  // 获取推荐产品 section
  function getRecommendationsSection() {
    return document.querySelector('.id_product-recommendations, section[id*="product-recommendations"]');
  }

  // 获取 main-product section
  function getMainProductSection() {
    // 查找 main-product 的 shopify-section 容器
    var mainSection = document.querySelector('section.shopify-section[id*="main"]');
    if (mainSection) return mainSection;

    // 备用：通过 class 查找
    var mainProduct = document.querySelector('.t4s_se_main-product, .id_main-product');
    if (mainProduct) {
      return mainProduct.closest('section.shopify-section') || mainProduct.closest('.shopify-section');
    }

    return null;
  }

  // 隐藏推荐产品 section（防闪烁）
  function hideRecommendations() {
    var section = getRecommendationsSection();
    if (section) {
      section.style.opacity = '0';
      section.style.transition = 'opacity 0.3s ease';
    }
  }

  // 显示推荐产品 section
  function showRecommendations() {
    var section = getRecommendationsSection();
    if (section) {
      section.style.opacity = '1';
    }
  }

  // 移动推荐产品到 main-product 后面
  function moveRecommendationsUp() {
    var recommendations = getRecommendationsSection();
    var mainProduct = getMainProductSection();

    if (!recommendations) {
      console.warn('[AB Test] Could not find recommendations section');
      return false;
    }

    if (!mainProduct) {
      console.warn('[AB Test] Could not find main-product section');
      showRecommendations();
      return false;
    }

    // 获取推荐产品的 shopify-section 容器
    var recsSection = recommendations.closest('section.shopify-section') || recommendations.closest('.shopify-section') || recommendations;

    // 将推荐产品 section 移动到 main-product section 后面
    if (mainProduct.parentNode) {
      mainProduct.parentNode.insertBefore(recsSection, mainProduct.nextSibling);
      console.log('[AB Test] Recommendations moved after main-product (test variant)');
    }

    showRecommendations();
    return true;
  }

  // Clarity 打标
  function tagClarity(key, value) {
    if (window.clarity && typeof window.clarity === 'function') {
      window.clarity('set', key, value);
      console.log('[AB Test] Clarity tagged:', key, '=', value);
    }
  }

  // 统一追踪函数（PostHog + Clarity）
  function trackEvent(eventName, data) {
    // PostHog
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(eventName, data);
    }

    // Clarity 事件
    if (window.clarity && typeof window.clarity === 'function') {
      window.clarity('event', eventName.toLowerCase().replace(/\s+/g, '_'));
    }
  }

  // 追踪推荐产品点击
  function trackRecommendationClick(productEl, variant) {
    var productLink = productEl.closest('a[href*="/products/"]');
    var productUrl = productLink ? productLink.href : '';
    var productTitle = productEl.querySelector('.t4s-pr-title, .t4s-product-title, [class*="pr-title"]');
    var title = productTitle ? productTitle.textContent.trim() : '';

    // 从 URL 提取 product handle
    var handle = '';
    var match = productUrl.match(/\/products\/([^?#/]+)/);
    if (match) handle = match[1];

    var eventData = {
      experiment: FLAG_NAME,
      variant: variant,
      product_handle: handle,
      product_title: title,
      product_url: productUrl,
      position: variant === TEST_VARIANT ? 'moved_up' : 'original'
    };

    trackEvent('Recommendation Clicked', eventData);
    console.log('[AB Test] Recommendation clicked:', eventData);
  }

  // 绑定推荐产品点击事件
  function bindClickTracking(variant) {
    var recommendations = getRecommendationsSection();
    if (!recommendations) return;

    // 使用事件委托监听点击
    recommendations.addEventListener('click', function(e) {
      var productItem = e.target.closest('.t4s-pr, .t4s-product, [class*="product-item"], [class*="pr-item"]');
      if (productItem) {
        trackRecommendationClick(productItem, variant);
      }
    });
  }

  // 应用 A/B 测试变体
  function applyVariant(variant) {
    var actualVariant = variant || 'control';
    console.log('[AB Test] shopify-block variant:', actualVariant);

    // Clarity 打标 - 标记实验组
    tagClarity('ab_shopify_block', actualVariant);
    tagClarity('ab_test_name', 'Product Recommendations Position');

    // 实验曝光数据
    var exposureData = {
      experiment: FLAG_NAME,
      variant: actualVariant,
      test_name: 'Product Recommendations Position'
    };

    if (variant === TEST_VARIANT) {
      // Test 组：移动推荐产品位置
      moveRecommendationsUp();
    } else {
      // Control 组：保持原位置
      showRecommendations();
      console.log('[AB Test] Control variant - keeping original position');
    }

    // 追踪实验曝光（多平台）
    trackEvent('AB Test Exposure', exposureData);

    // 绑定点击追踪
    bindClickTracking(actualVariant);
  }

  // 获取或生成实验分组
  function getVariant() {
    var STORAGE_KEY = 'ab_' + FLAG_NAME;
    var TEST_RATIO = 0.5; // 50% 进入 test 组

    // 1. 检查 URL 参数强制指定
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('ab_variant') || urlParams.get('variant');
    if (urlVariant === 'test' || urlVariant === 'control') {
      localStorage.setItem(STORAGE_KEY, urlVariant);
      console.log('[AB Test] Variant from URL:', urlVariant);
      return urlVariant;
    }

    // 2. 检查 localStorage 已存储的分组
    var storedVariant = localStorage.getItem(STORAGE_KEY);
    if (storedVariant === 'test' || storedVariant === 'control') {
      console.log('[AB Test] Variant from storage:', storedVariant);
      return storedVariant;
    }

    // 3. 检查 PostHog feature flag（如果可用）
    if (window.posthog && typeof window.posthog.getFeatureFlag === 'function') {
      var phFlag = window.posthog.getFeatureFlag(FLAG_NAME);
      if (phFlag === 'test' || phFlag === 'control') {
        localStorage.setItem(STORAGE_KEY, phFlag);
        console.log('[AB Test] Variant from PostHog:', phFlag);
        return phFlag;
      }
    }

    // 4. 随机分配（基于用户 ID 或随机数）
    var userId = '';
    try {
      // 尝试获取 Shopify customer ID
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
        userId = window.ShopifyAnalytics.meta.page.customerId || '';
      }
    } catch (e) {}

    var hash;
    if (userId) {
      // 基于用户 ID 的确定性分配
      hash = 0;
      for (var i = 0; i < userId.length; i++) {
        hash = ((hash << 5) - hash) + userId.charCodeAt(i);
        hash = hash & hash;
      }
      hash = Math.abs(hash) / 2147483647;
    } else {
      // 随机分配
      hash = Math.random();
    }

    var newVariant = hash < TEST_RATIO ? 'test' : 'control';
    localStorage.setItem(STORAGE_KEY, newVariant);
    console.log('[AB Test] Variant randomly assigned:', newVariant);
    return newVariant;
  }

  // 初始化
  function init() {
    // 先隐藏推荐产品防止闪烁
    hideRecommendations();

    // 等待 DOM 完全加载后执行
    function run() {
      var variant = getVariant();
      applyVariant(variant);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  // 立即执行
  init();
})();
